import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import { useLocalization } from '@shared-ui/localization-context';
import { EGDSIcon, EGDSIconSize } from '../../icons/icon/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-input.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { EGDSContextWrapper } from '../../utils/context-provider/index.esm.js';
import { analyticsTracker } from '../../utils/analytics-tracker/index.esm.js';
const getClassNameList = classNames.bind(styles);
class FauxInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mounted: false
    };
    this.handleClear = this.handleClear.bind(this);
  }
  componentDidMount() {
    this.setState({
      mounted: true
    });
  }
  handleClear() {
    const {
      handleClear
    } = this.props;
    if (typeof handleClear === 'function') {
      handleClear();
    }
  }
  render() {
    const {
      mounted
    } = this.state;
    const {
      className,
      domRef,
      children,
      analytics,
      hasClearButton,
      label,
      l10n,
      ...attrs
    } = this.props;
    const showClearButton = mounted && hasClearButton && children;
    // Dummy button is needed to re-render the faux input especially on Firefox for cases where clear button is not required
    const showDummyButton = mounted && !hasClearButton && children;
    const cssClassNames = getClassNameList('uitk-faux-input', className);
    const iconTitle = [l10n.formatText('clear'), label].join(' ');
    if (attrs.handleClear) {
      delete attrs.handleClear;
    }
    return jsx(EGDSContextWrapper, {
      children: (context, data) => jsxs(Fragment, {
        children: [jsx("button", {
          ...attrs,
          type: "button",
          className: getClassNameList(cssClassNames, context === 'uitk-field-context' && 'uitk-field-faux-input', data?.icon && 'uitk-field-faux-input-hasicon', data?.invalid && 'uitk-field-faux-input-invalid'),
          ref: domRef,
          onClickCapture: analytics && analyticsTracker.bind(this, analytics),
          children: children
        }), showDummyButton && jsx("button", {
          className: getClassNameList('is-visually-hidden'),
          type: "button",
          "aria-hidden": "true",
          tabIndex: -1
        }), showClearButton && jsx("button", {
          className: getClassNameList('uitk-clear-button', 'uitk-input-cta'),
          type: "button",
          onClick: this.handleClear,
          children: jsx(EGDSIcon, {
            name: "cancel",
            size: EGDSIconSize.SMALL,
            id: "faux-input-clear-button",
            title: iconTitle
          })
        })]
      })
    });
  }
}
const EGDSFauxInput = props => {
  const l10n = useLocalization();
  return jsx(FauxInput, {
    l10n: l10n,
    ...props
  });
};
export { EGDSFauxInput };